import React from 'react';

/**
 * 👤 SIZDAN KUTILMOQDA — platforma to'xtab odamni kutayotgan hamma narsa.
 *
 * Nega alohida: bu holatlar TURLI ekranlarda yotardi (savol — Jarayonlarda,
 * tasdiq — o'sha yerda, konsol login — Konsollar sahifasidagi logda, reja qadami —
 * doskada). Natijada operator nimadir kutayotganini bilmay qolardi.
 *
 * `authFetch` har render'da yangi identity — effekt dep'iga QO'YILMAYDI.
 * 🧠 Agentga (2026-11-03): har element o'sha loyihaning 🧠 Agent yozuv maydoniga konteksti bilan tushadi (`onAskAgent`) —
 * agent o'zi hal qiladi (masalan test kalitini qo'yadi) yoki qanday qilishni aytadi, hal bo'lgach ro'yxatdan oladi (190).
 */
const KIND = {
  clarify:       { icon: '❓', label: 'Savolga javob kerak', cls: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300' },
  plan:          { icon: '📝', label: 'Reja tasdiq kutmoqda', cls: 'bg-indigo-100 dark:bg-indigo-900/50 text-indigo-800 dark:text-indigo-300' },
  approve:       { icon: '⚠️', label: 'Tasdiq kutmoqda',     cls: 'bg-primary-100 dark:bg-primary-900/50 text-primary-900 dark:text-primary-200' },
  console_login: { icon: '🔐', label: 'Konsolga kirish',     cls: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400' },
  todo_operator: { icon: '📋', label: 'Sizning qadamingiz',  cls: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300' },
  supervisor_question: { icon: '🧑‍💼', label: 'Nazoratchi savoli',  cls: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400' },
  supervisor_proposal: { icon: '🧑‍💼', label: 'Nazoratchi taklifi', cls: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300' },
  playbook:      { icon: '🧭', label: 'Integratsiya savoli',  cls: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300' },
  // 👥 F5: mijoz vazifasi operator/egasi ruxsatini kutmoqda; mijozning narx/muddat savoli.
  task_approval: { icon: '🙋', label: 'Mijoz vazifasi — ruxsat', cls: 'bg-violet-100 dark:bg-violet-900/50 text-violet-800 dark:text-violet-300' },
  escalation:    { icon: '💬', label: 'Mijoz savoli',         cls: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-800 dark:text-emerald-300' },
  // 🔑 Test muhitida .env kaliti yetishmaydi (services/envGap.js) — ilgari xaritada yo'q edi: belgisiz «👤» chiqardi.
  env_gap:       { icon: '🔑', label: 'Test env kaliti',      cls: 'bg-sky-100 dark:bg-sky-900/50 text-sky-800 dark:text-sky-300' },
};
const ORDER = ['console_login', 'playbook', 'escalation', 'task_approval', 'supervisor_question', 'clarify', 'plan', 'approve', 'env_gap', 'supervisor_proposal', 'todo_operator'];

// 🧠 Agentga — element konteksti (operator izoh qo'shib Enter bosadi). Agent qoidasi: operatorAgent «👤→🧠 SIZDAN KUTILMOQDA».
function agentText(it) {
  const k = KIND[it.kind] || { icon: '👤', label: it.kind };
  const refs = [
    it.taskId && `vazifa #${it.taskId}`, it.moduleId && `modul #${it.moduleId}`, it.todoId && `reja kartasi #${it.todoId}`,
    it.supervisorItemId && `Nazoratchi #${it.supervisorItemId}`, it.runId && `ssenariy #${it.runId}`, it.escalationId && `mijoz savoli #${it.escalationId}`,
    it.profile && `konsol «${it.profile}»`,
  ].filter(Boolean);
  return [
    `[👤 SIZDAN KUTILMOQDA — ${k.icon} ${k.label}${it.projectName ? ` · ${it.projectName}` : ''} · kalit ${it.key}]`,
    String(it.title || '').trim(),
    String(it.detail || '').trim(),
    refs.length ? `(${refs.join(', ')})` : '',
    '',
    "Shuni hal qil — o'zing qila olsang qil, qila olmasang qanday qilishni ayt.",
  ].filter((x, i) => x || i === 4).join('\n');
}

export default function WaitingPanel({ authFetch, apiUrl, onOpenTask, onOpenConsole, onOpenTodo, onOpenPlaybook, agentOkFor = null, onAskAgent = null }) {
  const [items, setItems] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const afRef = React.useRef(authFetch);
  afRef.current = authFetch;

  const [busy, setBusy] = React.useState('');
  const [answers, setAnswers] = React.useState({});   // escalationId -> matn

  // 🙋 Mijoz vazifasiga ruxsat / 💬 mijoz savoliga javob (F5) — shu yerning o'zida.
  const post = async (url, body, key, okMsg) => {
    setBusy(key);
    try {
      const r = await afRef.current(`${apiUrl}${url}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { window.alert(d.error || 'Bajarib bo\'lmadi'); return; }
      setItems(prev => (prev || []).filter(i => i.key !== key));
      if (okMsg) setFlash(okMsg);
    } catch { window.alert('Ulanib bo\'lmadi'); }
    finally { setBusy(''); }
  };
  const [flash, setFlash] = React.useState('');
  React.useEffect(() => { if (!flash) return undefined; const t = setTimeout(() => setFlash(''), 3500); return () => clearTimeout(t); }, [flash]);

  // 🧹 Ro'yxatdan olib tashlash. VAZIFA O'CHIRILMAYDI va TASDIQLANMAYDI —
  // faqat «bu haqda eslatma» (eski, allaqachon hal qilingan navbat uchun).
  const dismiss = async (body, label) => {
    setBusy(label);
    try {
      const r = await afRef.current(`${apiUrl}/waiting/dismiss`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (r.ok) setItems(prev => (prev || []).filter(i =>
        body.key ? i.key !== body.key : i.kind !== body.kind));
    } catch { /* jim */ }
    finally { setBusy(''); }
  };

  const load = React.useCallback(async () => {
    try {
      const r = await afRef.current(`${apiUrl}/waiting`);
      const j = await r.json().catch(() => null);
      if (r.ok && j && Array.isArray(j.items)) setItems(j.items);
    } catch { /* jim — keyingi tikda qayta urinadi */ }
  }, [apiUrl]);

  React.useEffect(() => {
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 30000);
    return () => clearInterval(t);
  }, [load]);

  const n = items ? items.length : 0;
  // Bloklovchi (agent/vazifa KUTIB turgan) narsalar alohida sanaladi — ular shoshilinch.
  const urgent = items ? items.filter(i => i.kind === 'console_login' || i.kind === 'clarify' || i.kind === 'plan' || i.kind === 'playbook' || i.kind === 'escalation' || i.kind === 'task_approval').length : 0;
  if (!items) return null;

  const sorted = [...items].sort((a, b) => ORDER.indexOf(a.kind) - ORDER.indexOf(b.kind));
  const agentBtn = (it) => (
    <button onClick={() => { onAskAgent(it, agentText(it)); setOpen(false); }}
      title="🧠 Agentga tashlash — element konteksti o'sha loyihaning Agent yozuv maydoniga tushadi (izoh qo'shib Enter bosing). Agent o'zi hal qiladi (masalan test kalitini qo'yadi) yoki qanday qilishni aytadi; hal bo'lgach ro'yxatdan oladi."
      className="px-2.5 py-1 rounded-lg text-xs border border-primary-300 dark:border-primary-700 text-primary-700 dark:text-primary-300 hover:bg-primary-50 dark:hover:bg-primary-900/30">🧠 Agentga</button>
  );
  const act = (it) => {
    if (it.kind === 'console_login') return onOpenConsole && onOpenConsole(it);
    if (it.kind === 'todo_operator') return onOpenTodo && onOpenTodo(it);
    if (it.kind === 'playbook') return onOpenPlaybook && onOpenPlaybook(it);
    // 🧑‍💼 Nazoratchi pulti telefon panelida (/m) — u yerda ✅ Bajar / javob bor.
    if (it.kind === 'supervisor_proposal' || it.kind === 'supervisor_question') return window.open(it.url || '/m', '_blank');
    return onOpenTask && onOpenTask(it);
  };

  return (
    <>
      <button onClick={() => { setOpen(o => !o); load(); }}
        title="Sizdan kutilayotgan ishlar"
        className={`h-10 shrink-0 inline-flex items-center gap-1.5 px-3 rounded-lg shadow-sm text-sm font-medium transition border
          ${urgent ? 'bg-red-600 text-white border-red-600 hover:bg-red-700'
                   : n ? 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 border-gray-200 dark:border-gray-700'
                       : 'bg-white/70 dark:bg-gray-800/70 text-gray-400 border-gray-200 dark:border-gray-700'}`}>
        <span className="text-base leading-none">👤</span>
        {n > 0 && (
          <span className={`min-w-[20px] h-5 px-1 flex items-center justify-center text-xs font-bold rounded-full ${urgent ? 'bg-white/25 text-white' : 'bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-100'}`}>{n}</span>
        )}
      </button>

      {/* z-[55]: suzuvchi ⏳ Jarayonlar oynasi (z-50) ochiq bo'lsa ham ro'yxat ustida ko'rinsin (to'liq ekran z-60 dan past). */}
      {open && (
        <div className="fixed top-16 right-4 z-[55] w-[26rem] max-h-[70vh] overflow-auto rounded-lg bg-white dark:bg-gray-800 shadow-lg border border-gray-200 dark:border-gray-700">
          <div className="sticky top-0 bg-white dark:bg-gray-800 px-4 py-3 border-b flex items-center justify-between">
            <div>
              <div className="font-semibold text-gray-900 dark:text-white">👤 Sizdan kutilmoqda</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">{n ? `${n} ta element` : 'Hozircha hech narsa kutilmayapti'}</div>
            </div>
            <button onClick={() => setOpen(false)} className="text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-lg leading-none">✕</button>
          </div>
          {ORDER.filter(kd => sorted.filter(i => i.kind === kd).length >= 3).map(kd => (
            <div key={`bulk-${kd}`} className="px-4 py-2 border-b bg-gray-50 dark:bg-gray-700 flex items-center justify-between gap-2">
              <span className="text-[11px] text-gray-500 dark:text-gray-400">
                {KIND[kd].icon} {KIND[kd].label} — {sorted.filter(i => i.kind === kd).length} ta
              </span>
              <button disabled={busy === kd}
                onClick={() => {
                  if (!window.confirm(`${KIND[kd].label}: hammasi ro'yxatdan olib tashlansinmi?\n\nVazifalar O'CHIRILMAYDI va TASDIQLANMAYDI — faqat bu ro'yxatda ko'rinmaydi.`)) return;
                  dismiss({ kind: kd }, kd);
                }}
                className="text-[11px] px-2 py-1 rounded border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-white dark:hover:bg-gray-700 disabled:opacity-40">
                {busy === kd ? '⏳' : '🧹 Tozalash'}
              </button>
            </div>
          ))}
          {flash && <div className="px-4 py-2 text-xs bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 border-b">{flash}</div>}
          {!n && <div className="p-6 text-sm text-gray-500 dark:text-gray-400 text-center">✅ Hammasi joyida — platforma o'z ishini qilyapti.</div>}
          <div className="divide-y">
            {sorted.map(it => {
              const k = KIND[it.kind] || { icon: '👤', label: '', cls: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300' };
              return (
                <div key={it.key} className="p-3.5 hover:bg-gray-50 dark:hover:bg-gray-700">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-semibold ${k.cls}`}>{k.icon} {k.label}</span>
                    {it.projectName && <span className="text-[11px] text-gray-400">{it.projectName}</span>}
                  </div>
                  <div className="text-sm font-medium text-gray-900 dark:text-white">{it.title}</div>
                  {it.detail && <div className={`text-xs text-gray-500 dark:text-gray-400 mt-0.5 ${it.kind === 'task_approval' || it.kind === 'escalation' ? 'whitespace-pre-wrap line-clamp-6' : 'line-clamp-2'}`}>{it.detail}</div>}
                  {it.kind === 'task_approval' && (
                    <div className="flex items-center gap-2 mt-2">
                      <button disabled={busy === it.key}
                        onClick={() => post(`/task-approvals/${it.taskId}/approve`, {}, it.key, `✅ #${it.taskId} ishga tushdi`)}
                        className="px-2.5 py-1 rounded-lg text-xs bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50">{busy === it.key ? '⏳' : '✅ Ishga tushirish'}</button>
                      <button disabled={busy === it.key}
                        onClick={() => { const note = window.prompt('Rad etish sababi (mijozga boradi):', ''); if (note === null) return; post(`/task-approvals/${it.taskId}/reject`, { note }, it.key, `✖ #${it.taskId} rad etildi`); }}
                        className="px-2.5 py-1 rounded-lg text-xs border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50">✖ Rad etish</button>
                      {onAskAgent && agentOkFor && agentOkFor(it) && agentBtn(it)}
                    </div>
                  )}
                  {it.kind === 'escalation' && (
                    <div className="mt-2 space-y-1.5">
                      <textarea rows={2} value={answers[it.escalationId] || ''} placeholder="Javobingiz (mijozga boradi)…"
                        onChange={(e) => setAnswers(a => ({ ...a, [it.escalationId]: e.target.value }))}
                        className="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white text-xs px-2 py-1.5" />
                      <div className="flex items-center gap-2">
                        <button disabled={busy === it.key || !(answers[it.escalationId] || '').trim()}
                          onClick={() => post(`/escalations/${it.escalationId}/answer`, { answer: answers[it.escalationId] }, it.key, '📨 Javob mijozga yuborildi')}
                          className="px-2.5 py-1 rounded-lg text-xs bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50">{busy === it.key ? '⏳' : '📨 Javob berish'}</button>
                        <button disabled={busy === it.key}
                          onClick={() => { if (window.confirm('Savol javobsiz yopilsinmi? (mijozga xabar bormaydi)')) post(`/escalations/${it.escalationId}/close`, {}, it.key, 'Yopildi'); }}
                          className="px-2 py-1 rounded-lg text-xs text-gray-400 hover:text-gray-700 dark:hover:text-gray-200">Yopish</button>
                        {onAskAgent && agentOkFor && agentOkFor(it) && agentBtn(it)}
                      </div>
                    </div>
                  )}
                  {!(it.kind === 'task_approval' || it.kind === 'escalation') && <div className="flex items-center gap-2 mt-2">
                    <button onClick={() => { act(it); setOpen(false); }}
                      className="px-2.5 py-1 rounded-lg text-xs bg-primary-700 dark:bg-primary-600 text-white hover:bg-primary-800 dark:hover:bg-primary-700">
                      {it.kind === 'console_login' ? '🔐 Konsolga o`tish'
                        : it.kind === 'todo_operator' ? '📋 Rejada ochish'
                        : it.kind === 'playbook' ? '🧭 Javob berish'
                        : (it.kind === 'supervisor_proposal' || it.kind === 'supervisor_question') ? '🧑‍💼 Nazoratchida ochish' : '↗ Ochish'}
                    </button>
                    {onAskAgent && agentOkFor && agentOkFor(it) && agentBtn(it)}
                    <button disabled={busy === it.key}
                      onClick={() => dismiss({ key: it.key }, it.key)}
                      title="Ro'yxatdan olib tashlash (vazifa o'chirilmaydi, tasdiqlanmaydi)"
                      className="px-2 py-1 rounded-lg text-xs text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-40">
                      {busy === it.key ? '⏳' : '✕'}
                    </button>
                  </div>}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
